import React from 'react';

import { embedMarketingTrackingIntoURL } from '@lendi-jam/jam-link';
import GenericLmiCalculator from '@lendi-jam/lmi-calculator';

import { GenericLmiCalculatorContent } from '#contentTypes/GenericLmiCalculator';

interface PrismicGenericLmiCalculatorProps {
  component: GenericLmiCalculatorContent;
}

const PrismicGenericLmiCalculator: React.FC<PrismicGenericLmiCalculatorProps> = ({
  component: { primary },
}) => (
  <GenericLmiCalculator
    disclaimer={primary.disclaimer?.text}
    resultHeading={primary.result_heading?.text}
    resultBody={primary.result_body?.text}
    calculatorHeading={primary.calculator_heading?.text}
    buttonLink={embedMarketingTrackingIntoURL(primary.button_link?.url)}
    buttonText={primary.button_text?.text}
  />
);

export default PrismicGenericLmiCalculator;